module.exports = __webpack_public_path__ + "static/web-scraping-automation-sm-b04ea45f39f4f8a7c535488bde52d785.png";